export default __webpack_public_path__ + "1d7f25a862d38d54583df4da634d2ff7.png";